// extracted by mini-css-extract-plugin
export default {"Icon":"WindowIcon_Icon__2xszp"};